<template>
  <DataView
    :context="context"
    :defaultCheckedCols="checkedCols"
    :defaultCheckedMetrics="checkedMetrics"
    :fixedColumns="fixedColumns"
    :plotMetrics="plotMetrics"
    :initialTemplate="template"
    :defaultSort="defaultSort"
    :back="parseInt(back)"
  ></DataView>
</template>

<script>
import DataView from "@/components/DataView";
export default {
  name: "Fraud",
  components: { DataView },
  props :{
    template: {
      default: "Default",
      type:  String
    },
    back: {
      default: "0",
      type:  String
    }
  },
  data() {
    return {
      context: "fraud",
      defaultSort: "Total Visits",
      checkedCols: ["AdNetwork"],
      checkedMetrics: [
        "Total Visits",
        "Suspicious Visits",
        "Fraudulent Visits",
        "IVT",
        "Fraudulent Visits Rate",
        "Suspicious Visits Rate",
        "IVT Rate",
      ],
      plotMetrics: ["Total Visits", "IVT Rate"],
      fixedColumns: false,
    };
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Fraud.vue